<i18n>
{
  "en": {
    "title": "Probe data conversion",
    "subtitle": "Set the values to convert",
    "info":{
      "message":"Depending on the interface, specific parameters need to be set in order to convert the raw data into the actual measure. You can usually find those parameters in your probe's datasheet or instruction manual."
    },
    "minOutput": "Minimum output value",
    "maxOutput": "Maximum output value"
  },
  "it": {
    "title": "Conversione dati della sonda",
    "subtitle": "Imposta i valori da convertire",
    "info":{
      "message":"A seconda dell'interfaccia, specifici parametri devono essere settati per convertire il dato grezzo nella misura effettiva. Solitamente puoi trovare quei parametri nel datasheet o del manuale istruzioni della sonda."
    },
    "minOutput": "Valore minimo dei dati convertiti",
    "maxOutput": "Valore massimo dei dati convertiti"
  }
}
</i18n>
<template>
  <div>
    <div class="d-flex align-items-center mb16">
      <move-text p b class="mr16"> {{ $t("title") }}: </move-text>
      <move-info rigth>
        <template #icon>
          <font-awesome-icon icon="fa-solid fa-circle-info" />
        </template>
        <div class="w400 p16">
          <move-text p> {{ $t("info.message") }}</move-text>
        </div>
      </move-info>
    </div>
    <move-text p class="mb8"> {{ $t("subtitle") }}: </move-text>
    <div class="d-flex align-items-center">
      <div>
        <move-text caption> {{ $t("minOutput") }} </move-text>
        <move-input-number
          tertiary
          v-model="vMinOutput"
          :valid="getValidation.minOutput"
          class="w300"
          :disabled="getIsMappedMode"
        >
          <move-text p> {{ getUnit.minOutput }} </move-text>
        </move-input-number>
      </div>
      <font-awesome-icon class="px16 mt16" icon="fa-solid fa-arrow-right"/>
      <div>
        <move-text caption>{{ $t("maxOutput") }}</move-text>
        <move-input-number
          tertiary
          v-model="vMaxOutput"
          :valid="getValidation.maxOutput"
          class="w300"
          :disabled="getIsMappedMode"
        >
          <move-text p> {{ getUnit.maxOutput }} </move-text>
        </move-input-number>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "scn-data-conversion-ymin-ymax",
  props: {
    rawUnit:{
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      getTempSensor: "settings/getTempSensor",
      getTempSensorUserConfig: "settings/getTempSensorUserConfig",
      getTempSensorChannel0: "settings/getTempSensorChannel0",
      getSensorType: "settings/getSensorType",
      getProbeName: "settings/getProbeName",
      getConversionFormula: "settings/getConversionFormula",
      getMesUnit: "settings/getMesUnit",
      getIsMappedMode: "settings/getIsMappedMode",
    }),
    getUnit() {
      return {
        minOutput: this.getMesUnit,
        maxOutput: this.getMesUnit
      };
    },
    getValidation() {
      return {
        minOutput: typeof this.vMinOutput === 'number',
        maxOutput: typeof this.vMaxOutput === 'number'
      };
    },
    getEntireValidation() {
      return this.getValidation.minOutput && this.getValidation.maxOutput;
    },
    vMinOutput: {
      get() {
        return (
          (this.getConversionFormula && this.getConversionFormula.yMin)
        );
      },
      set(minOutput) {
        this.updateConversionFormula({ yMin: this.validateField(minOutput) });
      }
    },
    vMaxOutput: {
      get() {
        return (
          (this.getConversionFormula && this.getConversionFormula.yMax)
        );
      },
      set(maxOutput) {
        this.updateConversionFormula({ yMax: this.validateField(maxOutput) });
      }
    }
  },
  methods: {
    ...mapActions({
      setTempSensor: "settings/setTempSensor",
      updateValidationTempSensor: "settings/updateValidationTempSensor"
    }),
    validateField(value) {
      return value === "" ? null : value;
    },
    updateConversionFormula(fields = {}) {
      const sensor = this.getTempSensor;
      let conversionFormula =
        sensor.userConfig.channels[0].conversionFormula || {};
      conversionFormula = { ...conversionFormula, ...fields };
      sensor.userConfig.channels[0].conversionFormula = conversionFormula;
      this.setTempSensor(sensor);
    },
    updateValidation(valid){
      this.updateValidationTempSensor({
        field: "dataConversionYMinYMax",
        valid
      });
    }
  },
  watch: {
    getEntireValidation(valid) {
      this.updateValidationTempSensor({ field: "thresholdSampling", valid });
    }
  }
};
</script>

<style scoped></style>
